/**
 * The two columns that belong to whoever keeps the warehouse full rather than to whoever empties
 * it. Both are restocking thresholds: they say when to reorder from a supplier, and they have no
 * bearing on what a site may ask for.
 */
const STOCK_THRESHOLD_COLUMN_IDS = ["warningStockBalance", "minimumStockBalance"];

/**
 * Drop the warning and minimum threshold columns from a stock table's column set.
 *
 * The ordering screens use this. Somebody placing an order reads the balance and what is still
 * orderable; a red "minimum 40" beside a row they are ordering four of reads as a verdict on their
 * own order, which it is not. Filtering rather than hiding keeps the pair out of the column menu
 * too, so there is nothing to switch back on by accident.
 *
 * @param columns - A table's full column set, threshold columns included.
 * @returns The same set in the same order, without the two threshold columns.
 */
export function withoutStockThresholds<TColumn extends { id?: string }>(
	columns: readonly TColumn[],
): TColumn[] {
	return columns.filter((column) => !STOCK_THRESHOLD_COLUMN_IDS.includes(column.id ?? ""));
}
